import { Component, OnChanges, SimpleChanges, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WageParametersBaseComponent } from 'src/app/base-components/wage-parameters-base.component';
import { DictionaryService } from 'src/app/data/dictionary.service';
import { WageParametersStepFormGroupService } from '../../services/wage-parameters-step-form-group.service';

@Component({
  selector: 'app-multiple-wage-parameters-step',
  templateUrl: './multiple-wage-parameters-step.component.html',
  styleUrls: ['./multiple-wage-parameters-step.component.scss'],
  standalone: false
})
export class MultipleWageParametersStepComponent extends WageParametersBaseComponent implements OnChanges {
  private wageParametersInitialized = false;

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.wageParametersInitialized && !!changes.prefetchedAgreement?.currentValue) {
      this.wageParametersStepFormGroupService.patchFormGroupValue(this.wageParametersStepFormGroup, this.prefetchedAgreement);
      this.wageParametersInitialized = true;
    }

    if (this.prefetchedAgreement?.IsExtension) this.turnOnExtendedAgreementMode();
  }

  submit = () => { };
}